import { mockExam } from './mockExamData';

export function fetchExamMock() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockExam);
    }, 600);
  });
}

